import {
  LayoutDashboard,
  Radar,
  Shield,
  Bot,
  Gauge,
  BrickWall,
  FileWarning,
  Lightbulb,
  Globe,
  Lock,
  Layers,
  Settings,
  FileCode,
  ListFilter,
  ShieldAlert,
  ShieldCheck,
  KeyRound,
  FileCheck,
  ScrollText,
  BarChart3,
  Radio,
  Scale,
  GitPullRequest,
  Network,
  Sparkles,
  DatabaseZap,
  Zap,
  ScanLine,
  Plug,
  SlidersHorizontal,
  Wand2,
  Wrench,
  MessagesSquare,
  UserCheck,
  Search,
  BookMarked,
  BellRing,
  FileBarChart,
  Bell,
  Webhook,
  Building2,
  Users,
  User,
  Fingerprint,
  FolderKanban,
  BadgeCheck,
  Server,
} from "lucide-react";

/** v2 sidebar + flyout menu structure (Lucide icons). */
export const V2_NAV_ITEMS = [
  {
    title: "Overview",
    path: "/v2/overview",
    icon: LayoutDashboard,
    subItems: [],
  },
  {
    title: "Detection",
    path: "/v2/detection",
    icon: Radar,
    subItems: [
      {
        title: "Web application firewall",
        menus: [
          { title: "Dashboard", path: "/v2/detection/web_application/dashboard", icon: LayoutDashboard },
          { title: "WAF event", path: "/v2/detection/waf_event", icon: Shield },
        ],
      },
      {
        title: "Bot management",
        menus: [
          { title: "Dashboard", path: "/v2/detection/bot/dashboard", icon: LayoutDashboard },
          { title: "Bot event", path: "/v2/detection/bot_event", icon: Bot },
        ],
      },
      {
        title: "Rate limiting",
        menus: [
          { title: "Rate limit event", path: "/v2/detection/rate_limit_event", icon: Gauge },
        ],
      },
      {
        title: "Firewall",
        menus: [
          { title: "Firewall event", path: "/v2/detection/firewall_event", icon: BrickWall },
        ],
      },
    ],
  },
  {
    title: "Findings",
    path: "/v2/findings",
    icon: FileWarning,
    subItems: [
      {
        title: "Findings",
        menus: [
          { title: "Posture Findings", path: "/v2/findings/posture", icon: ShieldCheck },
          { title: "Threat Insights", path: "/v2/findings/threat-insights", icon: Lightbulb },
        ],
      },
    ],
  },
  {
    title: "Sites",
    path: "/v2/sites",
    icon: Globe,
    subItems: [],
  },
  {
    title: "SSL/TLS",
    path: "/v2/ssl-tls",
    icon: Lock,
    subItems: [
      {
        title: "SSL/TLS",
        menus: [
          { title: "Overview", path: "/v2/ssl-tls/overview", icon: LayoutDashboard },
          { title: "Configuration", path: "/v2/ssl-tls/configuration", icon: Settings },
        ],
      },
    ],
  },
  {
    title: "Services",
    path: "/v2/services",
    icon: Layers,
    subItems: [
      {
        title: "Web application firewall",
        menus: [
          { title: "WAF Overview", path: "/v2/services/waf_configuration", icon: LayoutDashboard },
          { title: "Configuration", path: "/v2/services/web_application/config", icon: Settings },
          { title: "WAF exception", path: "/v2/services/web_application/exceptions", icon: ListFilter },
          { title: "Custom rules", path: "/v2/services/web_application/custom_rules", icon: FileCode },
        ],
      },
      {
        title: "Rate limiting",
        menus: [
          { title: "Rate limiting rules", path: "/v2/services/rate_limit_rules", icon: Gauge },
        ],
      },
      {
        title: "Firewall",
        menus: [
          { title: "Firewall rules", path: "/v2/services/firewall_rules", icon: BrickWall },
        ],
      },
      {
        title: "Bot",
        menus: [
          { title: "Configuration", path: "/v2/services/bot/config", icon: Settings },
          { title: "Exception", path: "/v2/services/bot/exception", icon: ListFilter },
        ],
      },
      {
        title: "DDos",
        menus: [
          { title: "DDOS mitigation config", path: "/v2/services/ddos_config", icon: ShieldAlert },
          { title: "Exceptions", path: "/v2/services/ddos/exceptions", icon: ListFilter },
        ],
      },
    ],
  },
  {
    title: "CSP",
    path: "/v2/csp",
    icon: FileCode,
    subItems: [
      {
        title: "Content Security Policy",
        menus: [
          { title: "Script Inventory",        path: "/v2/csp/inventory",    icon: FolderKanban },
          { title: "Policy Configuration",   path: "/v2/csp/policy",       icon: Settings },
          { title: "Recent Violations",      path: "/v2/csp/violations",   icon: FileWarning },
          { title: "Route Policies",         path: "/v2/csp/routes",       icon: GitPullRequest },
          { title: "Violation Intelligence", path: "/v2/csp/intelligence", icon: BarChart3 },
          { title: "CSP Override",           path: "/v2/csp/override",     icon: ScrollText },
        ],
      },
    ],
  },
  {
    title: "MCP Security",
    path: "/v2/mcp",
    icon: Plug,
    subItems: [
      {
        title: "Get started",
        menus: [
          { title: "Onboarding", path: "/v2/mcp/onboard", icon: Wand2, featureKey: "mcp.endpoints" },
        ],
      },
      {
        title: "Insights",
        menus: [
          { title: "Overview",  path: "/v2/mcp/overview",  icon: Gauge, featureKey: "mcp.insights" },
          { title: "Endpoints", path: "/v2/mcp/endpoints", icon: Server, featureKey: "mcp.endpoints" },
          { title: "Events",    path: "/v2/mcp/events",    icon: Radar, featureKey: "mcp.insights" },
          { title: "Tools",    path: "/v2/mcp/tools",    icon: Wrench, featureKey: "mcp.insights" },
          { title: "Sessions", path: "/v2/mcp/sessions", icon: MessagesSquare, featureKey: "mcp.insights" },
          { title: "Agents",   path: "/v2/mcp/agents",   icon: Bot, featureKey: "mcp.insights" },
          { title: "Discovered", path: "/v2/mcp/discovered", icon: Search, featureKey: "mcp.insights" },
        ],
      },
      {
        title: "Policy",
        menus: [
          { title: "Configuration",  path: "/v2/mcp/configuration",   icon: Settings, featureKey: "mcp.endpoints" },
          { title: "Approvals",      path: "/v2/mcp/approvals",       icon: UserCheck, featureKey: "mcp.policy" },
          { title: "Settings",       path: "/v2/mcp/settings",        icon: SlidersHorizontal, featureKey: "mcp.policy" },
          { title: "Policy library", path: "/v2/mcp/policy-library",  icon: BookMarked, featureKey: "mcp.policy" },
        ],
      },
      {
        title: "Platform",
        menus: [
          { title: "Alerts",  path: "/v2/mcp/alerts",  icon: BellRing, featureKey: "mcp.alerts" },
          { title: "Reports", path: "/v2/mcp/reports", icon: FileBarChart, featureKey: "mcp.reports" },
        ],
      },
    ],
  },
  {
    title: "API Security",
    path: "/v2/api-security",
    icon: ShieldCheck,
    subItems: [
      {
        title: "Get started",
        menus: [{ title: "Overview", path: "/v2/api-security", icon: LayoutDashboard }],
      },
      {
        title: "Discovery",
        menus: [{ title: "Discovery", path: "/v2/api-security/discovery", icon: Radar, featureKey: "api.openapi_validation" }],
      },
      {
        title: "Controls",
        menus: [
          { title: "Authentication", path: "/v2/api-security/auth", icon: KeyRound, featureKey: "api.auth_primitives" },
          { title: "Schema validation", path: "/v2/api-security/schema", icon: FileCheck, featureKey: "api.openapi_validation" },
          { title: "DLP", path: "/v2/api-security/dlp", icon: ScrollText, featureKey: "api.dlp" },
          { title: "GraphQL", path: "/v2/api-security/graphql", icon: FileCode, featureKey: "api.graphql" },
          { title: "Authorization", path: "/v2/api-security/authorization", icon: ShieldAlert, featureKey: "api.auth_primitives" },
          { title: "Risk Score", path: "/v2/api-security/risk-score", icon: Scale, featureKey: "api.auth_primitives" },
          { title: "Threat Intel", path: "/v2/api-security/threat-intel", icon: Radio, featureKey: "api.auth_primitives" },
          { title: "Proposals", path: "/v2/api-security/proposals", icon: GitPullRequest, featureKey: "api.auth_primitives" },
          { title: "Dependencies", path: "/v2/api-security/dependencies", icon: Network, featureKey: "api.openapi_validation" },
          { title: "AI Callers", path: "/v2/api-security/ai-callers", icon: Sparkles, featureKey: "api.auth_primitives" },
        ],
      },
      {
        title: "Insights",
        menus: [
          { title: "Events", path: "/v2/api-security/events", icon: Zap },
          { title: "Events capture", path: "/v2/api-security/events_capture", icon: DatabaseZap, featureKey: "api.openapi_validation" },
          { title: "Posture", path: "/v2/api-security/posture", icon: BarChart3, featureKey: "api.posture_scanning" },
          { title: "Anomaly", path: "/v2/api-security/anomaly", icon: ScanLine, featureKey: "api.anomaly_engine" },
        ],
      },
      {
        title: "Integrations",
        menus: [{ title: "SIEM", path: "/v2/api-security/siem", icon: Plug, featureKey: "api.siem" }],
      },
    ],
  },
  {
    title: "Settings",
    path: "/v2/settings",
    icon: Settings,
    subItems: [
      {
        title: "Account",
        menus: [
          { title: "Account management", path: "/v2/settings/account", icon: User },
          { title: "Organisation settings", path: "/v2/settings/organisation", icon: Building2 },
          { title: "License & Subscription", path: "/v2/settings/license", icon: BadgeCheck },
          { title: "User Management", path: "/v2/settings/users", icon: Users },
          { title: "Role management", path: "/v2/settings/users?tab=roles", icon: Users },
        ],
      },
      {
        title: "Security",
        menus: [{ title: "SSO and Login Security", path: "/v2/settings/sso", icon: Fingerprint }],
      },
      {
        title: "Integrations",
        menus: [
          { title: "Integrations", path: "/v2/settings/webhooks", icon: Webhook },
          { title: "Alert rules", path: "/v2/settings/alerts", icon: Bell },
        ],
      },
      {
        title: "Compliance",
        menus: [{ title: "Audit Logs", path: "/v2/settings/audit-logs", icon: ScrollText }],
      },
      {
        title: "Project",
        menus: [{ title: "Project settings", path: "/v2/settings/project", icon: FolderKanban }],
      },
    ],
  },
];
